import React from "react";
import { Button, Modal } from "semantic-ui-react";
import useCustomerReviewModal from "@common/components/hooks/customerInteractionAdmin/useCustomerReviewModal";
import SimpleDateComponent from "../shared/forms/SimpleDateComponent";
import { DATE_FORMAT } from "@common/constants/datetime";
import { getDatePart, getSevenDaysInFuture } from "../helpers/datetime";

const StatusChangeModal = () => {
  const {
    selectedCustomerStatus,
    customerStatus,
    openStatusChangeModal,
    returnDate,
    setCustomerReviewModalState,
    onSave,
  } = useCustomerReviewModal();

  const setReturnDate = (_, { value }) =>
    setCustomerReviewModalState({ returnDate: value });

  const onCancel = () => {
    setCustomerReviewModalState({
      openStatusChangeModal: false,
      selectedCustomerStatus: null,
    });
  };

  return (
    <Modal
      open={openStatusChangeModal}
      closeIcon
      size="tiny"
      onClose={onCancel}
    >
      <Modal.Header>Customer Status Change</Modal.Header>
      <Modal.Content>
        <p>
          Do you want to change customer status from{" "}
          <b>{customerStatus?.text}</b> to <b>{selectedCustomerStatus?.text}</b>
          ?
        </p>
        {selectedCustomerStatus?.value === "isTakingABreak" && (
          <SimpleDateComponent
            name="returnDate"
            defaultValue={getDatePart(getSevenDaysInFuture())}
            value={returnDate}
            label="Select Return Date"
            onChange={setReturnDate}
            dateFormat={DATE_FORMAT}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" floated="left" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" color="green" onClick={onSave}>
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default StatusChangeModal;
